export const updatePageAndSend = (newPath: string) => {
    ga('set', 'page', `/${newPath}`);
    ga('send', 'pageview');
}